<template>
  <!-- accounts cards sections -->
  <section class="grid-view">
    <b-row>

      <b-col
        v-for="account in items"
        :key="account.id"
        lg="3"
        md="4"
      >
        <account-card :account="account" />
      </b-col>
    </b-row>
  </section>
  <!--/ accounts cards sections -->
</template>

<script>
import {
  BRow,
  BCol,
} from 'bootstrap-vue'
import AccountCard from '@/components/accounts/AccountCard'
import { ListTable } from '@/common/mixins/list'

export default {
  name: 'AccountsGrid',
  components: {
    BRow,
    BCol,
    AccountCard,
  },
  mixins: [ListTable],
}
</script>

<style scoped>

</style>
